module.exports = __webpack_public_path__ + "img/培训买一赠一.d3646361.png";